import { useLayoutEffect, useRef } from 'react';
import {
  GuardAction,
  GuardTarget,
  navigationGuardRegistry,
} from './navigationGuards';

export type ShouldBlockNavigation = (
  target: GuardTarget,
  action: GuardAction
) => boolean;

export const useRegisterNavigationGuard = (
  shouldBlock: ShouldBlockNavigation
) => {
  const shouldBlockRef = useRef(shouldBlock);

  useLayoutEffect(() => {
    shouldBlockRef.current = shouldBlock;
  });

  useLayoutEffect(
    () =>
      navigationGuardRegistry.register({
        shouldBlock: (target, action) => shouldBlockRef.current(target, action),
      }),
    []
  );
};
